import axios from 'axios';


export const getLabPackagesFromServer = (pageNum, serach, filterby, limit) => {
    console.log(pageNum, serach, "sdgaytsgdyt")

    // console.log(pageNum, SearchItem, "sdgaytsgdyt")

    // disease_uuid=all for DMP and in new doctall it will be diease wise
    return axios.get(`${process.env.REACT_APP_API_URL}/doctallnew/biocheck/by/diseaseuuid?disease_uuid=${filterby}&pagenum=${pageNum}&limit=${limit}&search=${serach}`)
};


export const comparePackagePrice = async (labPackageId) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/doctallnew/biocheck/package-data/${labPackageId}`);
}

export const comparePackagePriceWithArea = async (labPackageId, areaId) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/doctallnew/biocheck/package-data/compare/prcies?uuid=${labPackageId}&areaRef=${areaId}`);
  
    // return axios.get(`${process.env.REACT_APP_API_URL}/doctallnew/biocheck/lab-test-package-data/filter?uuid=${labPackageId}&areaRef=${areaId}`);
}

